import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { useConfig } from "@/composables/config";
import localize from "@/utils/localization";
import { wait } from "@/utils/utils";
import { useCleanupCategories } from "./Cleanup/categories";
import CleanupOperationSummary from "./Cleanup/CleanupOperationSummary.vue";
import CleanupResultDialog from "./Cleanup/CleanupResultDialog.vue";
import ReviewCleanupDialog from "./Cleanup/ReviewCleanupDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StorageManager',
    setup(__props) {
        const { config } = useConfig();
        const { cleanupCategories } = useCleanupCategories();
        const currentOperation = ref();
        const currentTotalItems = ref(0);
        const cleanupResult = ref();
        const refreshOperationId = ref();
        const reviewModal = ref(null);
        const resultModal = ref(null);
        const issuesUrl = "https://github.com/galaxyproject/galaxy/issues";
        function onReviewItems(operation, totalItems) {
            currentOperation.value = operation;
            currentTotalItems.value = totalItems;
            refreshOperationId.value = undefined;
            reviewModal.value?.openModal();
        }
        async function onConfirmCleanupSelected(selectedItems) {
            cleanupResult.value = undefined;
            resultModal.value?.openModal();
            await wait(1000);
            if (currentOperation.value) {
                cleanupResult.value = await currentOperation.value.cleanupItems(selectedItems);
                if (cleanupResult.value.hasUpdatedResults) {
                    refreshOperationId.value = currentOperation.value.id.toString();
                }
            }
        }
        return { __sfc: true, config, cleanupCategories, currentOperation, currentTotalItems, cleanupResult, refreshOperationId, reviewModal, resultModal, issuesUrl, onReviewItems, onConfirmCleanupSelected, localize, CleanupOperationSummary, CleanupResultDialog, ReviewCleanupDialog };
    }
});
